import { useLabel } from "../lib/labels";

/** display languageCode 기준 날짜 포맷 — en-GB 하드코딩 제거 */
export function formatWidgetDate(
  date: string,
  languageCode: string,
  style: "short" | "title" | "long" = "short",
): string {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  const loc = languageCode || "en";
  if (style === "title") {
    return d.toLocaleDateString(loc, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }
  if (style === "long") {
    return d.toLocaleDateString(loc, {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }
  return d.toLocaleDateString(loc, { month: "short", day: "numeric" });
}

/** 수량 라벨 — ``{n}`` 치환 (order_list 등 주문 카드 공용) */
export function useQtyLabel(quantity: number | undefined): string | null {
  const qtyLabel = useLabel("qty", "Qty : {n}");
  if (!quantity) return null;
  return qtyLabel.replace("{n}", String(quantity));
}
